import React from 'react'
import './indro.css'
import github from '../../img/github.png'
import linkedin from '../../img/linkedin.png'
import instagram from '../../img/instagram.png'
import boy from '../../img/boy.jpg'
import Vector1 from '../../img/Vector1.png'
import Vector2 from '../../img/Vector2.png'
import glassesimoj from '../../img/glassesimoji.png'
import thumbup from '../../img/thumbup.png'
import crown from '../../img/crown.png'
import FloatingDev from '../FloatingDev/FloatingDev'
import { themeContext } from '../../Context'
import { useContext } from 'react'


function Indro() {

// const transition={duration : 2, type:'spring'}

  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode
  return (
    <div className="indro">
      <div className="i-left">
        <div className="i-name">
          <span style={{color:darkMode? 'white' : ''}}>Hey I am </span>
          <span>Bilal Khan</span>
          <span style={{color:darkMode? 'orange' : ''}} >Front-end Developer</span><span> with Intermidate Level Of Experinace in Web Designing and development , production of Quality Work
          </span>
        </div>
        <button className="button i-btn">Hire Me</button>
        <div className="i-icon">
          <a href="#"> <img src={github} alt="" /></a>
          <a href="#"> <img src={linkedin} alt="" /></a>
          <a href="#"> <img src={instagram} alt="" /></a>
        </div>
      </div>

      <div className=" i-right " >
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={boy} alt="" />
        <img src={glassesimoj} alt="" />
        <div className="floatingDev floatingDevlast">  
        <FloatingDev img={crown} txt1='Web' txt2='developer' />
        </div>
        <div className='floatingDev '>
          <FloatingDev img={thumbup} txt1='Best Design' txt2='Award' />
        </div>
        
        {/* Blurs Effect */}
        <div className="i-blur" style={{ background: "rgb(250 210 255)" }}> </div>
        <div className="i-blur"
          style={{
            background: '#C1F5FF',
            top: '20rem',
            width: '21rem',
            height: '11rem',
            left: '-9rem',
          }}></div>

      </div>
    </div>
  )
}

export default Indro